// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import Tabby from "tabbyjs";

const TOGGLES = document.querySelectorAll(".tabby__tab__toggle");

if (TOGGLES.length > 0) {
    const TABS = new Tabby("[data-tabs]");

    TOGGLES.forEach((toggle) => {
        toggle.addEventListener("click", () => {
            TABS.toggle(toggle.getAttribute("href"));
        });
    });
}
